import React from 'react';
import { Field, FieldProps } from 'formik';

import { InputBase } from '@brighterion/br-ui';
import { HandleChange, HandleBlur } from './types';

type Props = React.ComponentProps<typeof InputBase> & {
    handleChange?: HandleChange;
    handleBlur?: HandleBlur;
    name: string;
    label?: string;
    id?: string;
};

export const FormikFieldString = ({ handleChange, handleBlur, name, label, id, ...rest }: Props) => {
    return (
        <Field name={name}>
            {({ field }: FieldProps) => (
                <InputBase
                    id={id ?? name}
                    name={name}
                    label={label}
                    value={field.value ?? ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    size='sm'
                    data-testid={`${name}-field`}
                    allowPan
                    {...rest}
                />
            )}
        </Field>
    );
};

export default FormikFieldString;
